(function () {
  if (window.__quantityDiscountInit) return;
  window.__quantityDiscountInit = true;

  function fmtMoney(cents) {
    var val = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + val;
  }

  function ksForm(n) {
    if (n === 1) return 'kus';
    if (n >= 2 && n <= 4) return 'kusy';
    return 'kusov';
  }

  function readDataNum(el, attr) {
    var n = parseFloat(el.dataset[attr]);
    return isNaN(n) ? 0 : n;
  }

  function QuantityDiscountBanner() {
    return Reflect.construct(HTMLElement, [], QuantityDiscountBanner);
  }
  QuantityDiscountBanner.prototype = Object.create(HTMLElement.prototype);
  QuantityDiscountBanner.prototype.constructor = QuantityDiscountBanner;

  QuantityDiscountBanner.prototype.connectedCallback = function () {
    this.t1q = parseInt(this.dataset.tier1Qty, 10) || 0;
    this.t1p = readDataNum(this, 'tier1Pct');
    this.t2q = parseInt(this.dataset.tier2Qty, 10) || 0;
    this.t2p = readDataNum(this, 'tier2Pct');
    this.unitPrice = parseInt(this.dataset.unitPriceCents, 10) || 0;
    var statusEl = this.querySelector('[data-qd-status]');
    this.defaultNote = statusEl ? statusEl.textContent : '';

    var sectionId = this.dataset.sectionId;
    var mainInput = sectionId ? document.getElementById('qty-' + sectionId) : null;
    this._qtyInputs = mainInput ? [mainInput] : [];

    var self = this;
    this._onChange = function () { self._tick(); };
    this._qtyInputs.forEach(function (i) {
      i.addEventListener('input', self._onChange);
      i.addEventListener('change', self._onChange);
    });

    this._onPillClick = function (e) {
      var pill = e.currentTarget;
      var target = parseInt(pill.dataset.qdQty, 10);
      if (isNaN(target) || target < 1) return;
      var input = self._qtyInputs[0];
      if (!input) return;
      input.value = target;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };
    this._pills = Array.prototype.slice.call(this.querySelectorAll('[data-qd-qty]'));
    this._pills.forEach(function (p) {
      p.addEventListener('click', self._onPillClick);
    });

    this._tick();
  };

  QuantityDiscountBanner.prototype.disconnectedCallback = function () {
    var self = this;
    (this._qtyInputs || []).forEach(function (i) {
      i.removeEventListener('input', self._onChange);
      i.removeEventListener('change', self._onChange);
    });
    (this._pills || []).forEach(function (p) {
      p.removeEventListener('click', self._onPillClick);
    });
  };

  QuantityDiscountBanner.prototype._readQty = function () {
    var q = 1;
    for (var idx = 0; idx < this._qtyInputs.length; idx++) {
      var v = parseInt(this._qtyInputs[idx].value, 10);
      if (!isNaN(v) && v > q) q = v;
    }
    return q;
  };

  QuantityDiscountBanner.prototype._tick = function () {
    var qty = this._readQty();
    var activePct = 0, activeTier = 0, nextTierQty = 0, nextTierPct = 0;

    if (this.t2q > 0 && qty >= this.t2q) {
      activePct = this.t2p;
      activeTier = 2;
    } else if (this.t1q > 0 && qty >= this.t1q) {
      activePct = this.t1p;
      activeTier = 1;
      nextTierQty = this.t2q;
      nextTierPct = this.t2p;
    } else {
      nextTierQty = this.t1q;
      nextTierPct = this.t1p;
    }

    this.querySelectorAll('[data-qd-tier]').forEach(function (el) {
      var t = parseInt(el.dataset.qdTier, 10);
      el.classList.toggle('is-active', t === activeTier);
      el.classList.toggle('is-passed', activeTier > t);
    });

    var maxQ = this.t2q > 0 ? this.t2q : this.t1q;
    var intensity = maxQ > 0 ? Math.min(qty / maxQ, 1) : 0;
    this.style.setProperty('--qd-intensity', intensity.toFixed(3));

    var bar = this.querySelector('[data-qd-bar]');
    if (bar) bar.style.width = (intensity * 100).toFixed(1) + '%';

    this.classList.toggle('is-tier-1', activeTier === 1);
    this.classList.toggle('is-tier-2', activeTier === 2);

    var status = this.querySelector('[data-qd-status]');
    if (!status) return;

    var lineTotal = this.unitPrice * qty;
    var savedCents = Math.round(lineTotal * activePct / 100);

    if (activeTier === 2) {
      status.innerHTML =
        '<strong>Maximálna zľava aktívna.</strong> Ušetríte <strong>' +
        fmtMoney(savedCents) +
        '</strong> z objednávky.';
    } else if (activeTier === 1) {
      var toNext = nextTierQty - qty;
      status.innerHTML =
        '<strong>Zľava aktívna:</strong> ušetríte <strong>' +
        fmtMoney(savedCents) +
        '</strong>. Pridajte <strong>' +
        toNext +
        ' ' +
        ksForm(toNext) +
        '</strong> a získate <strong>zľavu ' +
        nextTierPct +
        ' %</strong>.';
    } else if (nextTierQty > 0) {
      var toNext2 = nextTierQty - qty;
      status.innerHTML =
        'Pridajte ešte <strong>' +
        toNext2 +
        ' ' +
        ksForm(toNext2) +
        '</strong> a získajte <strong>zľavu ' +
        nextTierPct +
        ' %</strong>.';
    } else {
      status.textContent = this.defaultNote;
    }
  };

  if (!customElements.get('quantity-discount-banner')) {
    customElements.define('quantity-discount-banner', QuantityDiscountBanner);
  }
})();
